<template>
  <label class="el-radio">
    <span class="el-radio__input " :class="{'is-checked':value===label}">
      <span class="el-radio__inner"></span>
      <input @click="changeRadio" v-if="label==value" v-model="value" :value="label" type="radio"  class="el-radio__original">
    </span>
    <span class="el-radio__label">
      <slot></slot>
    </span>
  </label>
</template>
<style scoped>
  .el-radio__original {
    display: none;
  }

  .el-radio+.el-radio {
    margin-left: 30px;
  }

  .el-radio__input {
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    display: inline-block;
    line-height: 1;
    position: relative;
    vertical-align: middle;
  }

  .el-radio {
    color: #606266;
    font-weight: 500;
    line-height: 1;
    position: relative;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    font-size: 14px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #409eff;
    background: #409eff;
  }

  .el-radio__inner {
    border: 1px solid #dcdfe6;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    background-color: #fff;
    position: relative;
    cursor: pointer;
    display: inline-block;
    box-sizing: border-box;
  }

  .el-radio__input.is-checked .el-radio__inner:after {
    transform: translate(-50%, -50%) scale(1);
  }

  .el-radio__input.is-checked .el-radio__inner:after {
    transform: translate(-50%, -50%) scale(1);
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #409eff;
    background: #409eff;
  }

  .el-radio__inner:after {
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: #fff;
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform .15s ease-in;
  }

</style>
<script>
  export default {
    data() {
      return {
      }
    },
    props: ['value', 'label'],
    mounted() {

    },
    methods: {
        changeRadio(e){
            console.log(e)
        }
    }

    // this.checkedFlag = e.target.checked
  }

</script>
